(function($) {
    
	"use strict";

	var primaryNav = '.primary-header .dropdown-toggle';

	// Adds proper active states on click
	$(primaryNav).on('click', function(e) {
		e.stopPropagation();
        //e.preventDefault();
		var thisPanel = $(this).parent().find('.dropdown-menu');

		if(thisPanel.hasClass('panel-active')) {
			thisPanel.removeClass('panel-active');
			$(this).parent().removeClass('current-menu-item');
		}
		else {
            $('.dropdown').removeClass('current-menu-item');
			$('.dropdown-menu').removeClass('panel-active');
			$('.dropdown-col').removeClass('parent-active');
			thisPanel.addClass('panel-active');
			$(this).parent().addClass('current-menu-item');
		}

	});

	// Keeps entire dropdown in tact on click
	$('.primary-header .dropdown-full .dropdown-menu').on('click', function(e) {
		//e.preventDefault();
        e.stopPropagation();
	});

	// Close menu on click of close icon
	$('.primary-header .dropdown-full .dropdown-close').on('click', function(e) {
		$(this).closest('.dropdown-menu')
			.removeClass('panel-active')
			.closest('.dropdown-full')
			.removeClass('show');
        $('.dropdown').removeClass('current-menu-item');
	});

    $('body').click((event) => {
        // close dropdown on click outside of nav menu
        if (event.target.id !== 'dropdown-panel') {
            $('.dropdown .dropdown-menu').removeClass('panel-active');
			$('.dropdown').removeClass('current-menu-item');
        } 
    });


    var secondaryNav = '.primary-header .panel-toggle';

    $(secondaryNav).on('click', function(e) {
		//e.stopPropagation();
        e.preventDefault();
        console.log("secondary");
        
		var thisPanel = $(this).parent().find('.dropdown-panel');

		if(thisPanel.hasClass('panel-active')) {
			thisPanel.removeClass('panel-active');
			//$(this).parent().removeClass('current-menu-item');
		}
		else {
			$('.dropdown-panel').removeClass('panel-active');
			$('.dropdown-col').removeClass('parent-active');
			thisPanel.addClass('panel-active');
		}
        

	});


}(jQuery));